import {Dispatch} from "redux";

import {apiLink} from "../../app/routes/api_link";
import {IServices} from "../../app/services/IServices";
import {createRequestActionTypes} from "../../app/utils/request_response_utils/factories/create_request_action_types";
import {getRequest} from "../../app/utils/request_response_utils/request";

export interface IInitialSearchData {
    count: number;
    model: string[];
    body_type: string[];
    engine: string[];
    year: string[];
}

export const fetchInitialSearchDataTypes = createRequestActionTypes({view: "Home", type: "GET", name: "InitialSearchData"});

/**
 * Full facet payload from get-cars-search (slow). Homepage SSR no longer uses this —
 * offer count is seeded from cars-make-search instead. Kept for optional/client use.
 */
export const fetchInitialSearchData =
    (services: Partial<IServices>) =>
    (dispatch: Dispatch): Promise<IInitialSearchData | boolean> => {
        dispatch({type: fetchInitialSearchDataTypes.start});
        const url = apiLink.carDynamicSearch({})({});

        return getRequest(services, url, "fetchInitialSearchData")
            .then((json: IInitialSearchData) => {
                dispatch({type: fetchInitialSearchDataTypes.success, result: json});
                return json;
            })
            .catch(() => false);
    };
